/**
 * The address hash exactly as the page arrived, read when this module is first evaluated.
 *
 * Some host sites rewrite `location.hash` on their own (`#!/e/<slug>` becomes `#!` or `#!/`)
 * before the router initialises. Importing this module right after the public-path setup in
 * `index.js` puts the read ahead of every other piece of embed code, so a legacy hashbang link
 * still reaches `upgradeLegacyHashUrl`.
 */
export const bootHash: string =
  typeof window === 'undefined' ? '' : window.location.hash;
